'use client';
import React, { useState } from 'react';
import AuthorDetailsPopup from './AuthorDetailsPopup';
import { FactCheckAndVerifiedComp } from './FactCheckHoverContainer';

const MedVerifiedByContainer = ({ details }: any) => {
  const [showPopup, setShowPopup] = useState(false);
  return (
    <section
      onMouseEnter={() => setShowPopup(true)}
      onClick={() => setShowPopup(true)}
      onMouseLeave={() => setShowPopup(false)}
    >
      <section className={`relative `}>
        <FactCheckAndVerifiedComp
          details={details?.medicallyVerifiedBy}
          text='Medically verified by'
        />
        {showPopup && (
          <section className='absolute left-[0px] top-[10px] z-[5] animate-[scale-in-tl_.2s_ease-in] pt-[30px] transition duration-300 ease-in-out'>
            <AuthorDetailsPopup details={details?.medicallyVerifiedBy} />
          </section>
        )}
      </section>
    </section>
  );
};

export default MedVerifiedByContainer;
